var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikedWithoutBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7222 8.28378C28.2417 6.8156 26.2848 5.99819 24.1771 6C22.2544 6 20.4342 7.4785 19.0037 8.7381C17.5641 7.50558 15.7529 6.02709 13.8303 6.01797C11.7316 6.03638 9.79963 6.79758 8.33242 8.23842C5.23969 11.2651 5.22101 16.2038 8.28598 19.2581L17.4438 28.3565C17.8524 28.7734 18.4096 29 19.004 29C19.5984 29 20.1556 28.7734 20.5642 28.3565L29.722 19.2581C32.7592 16.2313 32.7594 11.3111 29.7222 8.28378Z",
    fill: "#F11057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikedWithoutBg);
export default __webpack_public_path__ + "static/media/likedWithoutBg.4f5a7c0cbbc2fa7f9665561a3e8d7deb.svg";
export { ForwardRef as ReactComponent };